import React from "react";
import { Container } from "@pixi/react";
import BasicTexture from "../../../Elements/Textures/BasicTexture";

const Logo = ({ dimensions, symbolSize, zIndex }) => {
  return (
    <Container
      name="Logo"
      position={{ x: dimensions.width / 2, y: 52 }}
      zIndex={zIndex}
    >
      <BasicTexture width={380} height={74} textureName="logo" />
    </Container>
  );
};

export default Logo;
